import * as Yup from 'yup'

const ProductPatternSchema = Yup.object().shape({
  label: Yup.string().required('Required')
})

export default ProductPatternSchema
